import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import PageMeta from "@/components/seo/PageMeta";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950 px-4 text-white">
      <PageMeta
        title="Page not found | skore.info"
        description="The requested skore.info route does not exist."
        canonicalPath={location.pathname}
        robots="noindex, nofollow"
      />
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-gray-300">Oops! Page not found</p>
        <a href="/" className="text-indigo-400 hover:text-indigo-300 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
